import type { FirebaseApp } from 'firebase/app';
import { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB6lKC4dYLoW4yT3sIXYWD8vJpxO_lxPms',
  authDomain: 'pathpoint-97f27.firebaseapp.com',
  projectId: 'pathpoint-97f27',
  storageBucket: 'pathpoint-97f27.firebasestorage.app',
  messagingSenderId: '352970398096',
  appId: '1:352970398096:web:6f456d8749de95ca0b3b15',
  measurementId: 'G-0350QYM9NZ',
};

export type FirebaseContext = {
  initialized: boolean;
  app: FirebaseApp;
};

const defaultContext: FirebaseContext = {
  initialized: false,
  app: {} as FirebaseApp,
};

export const firebaseContext = createContext<FirebaseContext>(defaultContext);

export const useFirebaseContextValue = (): FirebaseContext => {
  const [initialized, setInitialized] = useState(false);
  const [app, setApp] = useState<FirebaseApp>(defaultContext.app);

  useEffect(() => {
    const _app = initializeApp(FIREBASE_CONFIG);
    const _analytics = getAnalytics(_app);
    setApp(_app);
    setInitialized(true);
    console.log('Initialized Firebase', { app: _app, analytics: _analytics });
  }, []);

  const firebaseContextValue = useMemo<FirebaseContext>(
    () => ({
      initialized,
      app,
    }),
    [initialized, app],
  );

  return firebaseContextValue;
};

export const useFirebaseContext = () => {
  return useContext(firebaseContext);
};
